import { useMutation } from "@tanstack/react-query";
import {
  type ResendVerificationEmailCommand,
  postAuthResendVerificationEmail,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

export const useResendVerificationEmailMutation = () => {
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (command: ResendVerificationEmailCommand) =>
        postAuthResendVerificationEmail(command),
    ),
    onSuccess: () => {
      toast.success(t(Resources.Hooks.VerificationEmail.Success));
    },
    onError: () => {
      toast.error(t(Resources.Hooks.VerificationEmail.Error));
    },
  });
};
